import React from "react";
import ExploreGrid from '../ExploreGrid/ExploreGrid';

function DashHome() {
  return (
    <div className="dash_right">
      <ExploreGrid/>
    </div>
  );
}

export default DashHome;
